const CustomerRecordType = {
    Individual: 1,
    Corporate: 2
}

export default CustomerRecordType